/* tslint:disable */
/* eslint-disable */
/**
 * MAPIIO API
 * API mapové aplikace Mapiio pro klientskou JavaScriptovou / React část.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { CatalogItemEVO } from '../model';
// @ts-ignore
import { FeatureExportVO } from '../model';
// @ts-ignore
import { ImportedDataVO } from '../model';
// @ts-ignore
import { LayerEVO } from '../model';
// @ts-ignore
import { OrganisationEVO } from '../model';
// @ts-ignore
import { TopicEVO } from '../model';
// @ts-ignore
import * as Objs from './index'
// @ts-ignore
import { DataResponseVO, DataRequestVO, ExportRequestVO } from '@mc/data-filter-react';

/**
 * MapioDataImportControllerApi - axios parameter creator
 * @export
 */
export const MapioDataImportControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} kodOrganizace 
         * @param {CatalogItemEVO} [catalogItemEVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogItemImport: async (kodOrganizace: string, catalogItemEVO?: CatalogItemEVO, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'kodOrganizace' is not null or undefined
            assertParamExists('catalogItemImport', 'kodOrganizace', kodOrganizace)
            const localVarPath = `/api/data-import/catalog-item`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (kodOrganizace !== undefined) {
                localVarQueryParameter['kodOrganizace'] = kodOrganizace;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(catalogItemEVO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} layerId 
         * @param {string} kodOrganizace 
         * @param {Array<number>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearOldRecords: async (layerId: number, kodOrganizace: string, requestBody?: Array<number>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'layerId' is not null or undefined
            assertParamExists('clearOldRecords', 'layerId', layerId)
            // verify required parameter 'kodOrganizace' is not null or undefined
            assertParamExists('clearOldRecords', 'kodOrganizace', kodOrganizace)
            const localVarPath = `/api/data-import/clear-old`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (layerId !== undefined) {
                localVarQueryParameter['layerId'] = layerId;
            }

            if (kodOrganizace !== undefined) {
                localVarQueryParameter['kodOrganizace'] = kodOrganizace;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} kodOrganizace 
         * @param {Array<FeatureExportVO>} [featureExportVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dataImport: async (kodOrganizace: string, featureExportVO?: Array<FeatureExportVO>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'kodOrganizace' is not null or undefined
            assertParamExists('dataImport', 'kodOrganizace', kodOrganizace)
            const localVarPath = `/api/data-import/data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (kodOrganizace !== undefined) {
                localVarQueryParameter['kodOrganizace'] = kodOrganizace;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(featureExportVO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} kodOrganizace 
         * @param {File} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        imageImport: async (kodOrganizace: string, body?: File, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'kodOrganizace' is not null or undefined
            assertParamExists('imageImport', 'kodOrganizace', kodOrganizace)
            const localVarPath = `/api/data-import/image`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (kodOrganizace !== undefined) {
                localVarQueryParameter['kodOrganizace'] = kodOrganizace;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} kodOrganizace 
         * @param {LayerEVO} [layerEVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        layerImport: async (kodOrganizace: string, layerEVO?: LayerEVO, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'kodOrganizace' is not null or undefined
            assertParamExists('layerImport', 'kodOrganizace', kodOrganizace)
            const localVarPath = `/api/data-import/layer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (kodOrganizace !== undefined) {
                localVarQueryParameter['kodOrganizace'] = kodOrganizace;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(layerEVO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {OrganisationEVO} [organisationEVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organisationImport: async (organisationEVO?: OrganisationEVO, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/data-import/organisation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organisationEVO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} kodOrganizace 
         * @param {TopicEVO} [topicEVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        topicImport: async (kodOrganizace: string, topicEVO?: TopicEVO, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'kodOrganizace' is not null or undefined
            assertParamExists('topicImport', 'kodOrganizace', kodOrganizace)
            const localVarPath = `/api/data-import/topic`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (kodOrganizace !== undefined) {
                localVarQueryParameter['kodOrganizace'] = kodOrganizace;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(topicEVO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MapioDataImportControllerApi - functional programming interface
 * @export
 */
export const MapioDataImportControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MapioDataImportControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} kodOrganizace 
         * @param {CatalogItemEVO} [catalogItemEVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async catalogItemImport(kodOrganizace: string, catalogItemEVO?: CatalogItemEVO, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.catalogItemImport(kodOrganizace, catalogItemEVO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} layerId 
         * @param {string} kodOrganizace 
         * @param {Array<number>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clearOldRecords(layerId: number, kodOrganizace: string, requestBody?: Array<number>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.clearOldRecords(layerId, kodOrganizace, requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} kodOrganizace 
         * @param {Array<FeatureExportVO>} [featureExportVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dataImport(kodOrganizace: string, featureExportVO?: Array<FeatureExportVO>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImportedDataVO>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.dataImport(kodOrganizace, featureExportVO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} kodOrganizace 
         * @param {File} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async imageImport(kodOrganizace: string, body?: File, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.imageImport(kodOrganizace, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} kodOrganizace 
         * @param {LayerEVO} [layerEVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async layerImport(kodOrganizace: string, layerEVO?: LayerEVO, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.layerImport(kodOrganizace, layerEVO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {OrganisationEVO} [organisationEVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organisationImport(organisationEVO?: OrganisationEVO, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.organisationImport(organisationEVO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} kodOrganizace 
         * @param {TopicEVO} [topicEVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async topicImport(kodOrganizace: string, topicEVO?: TopicEVO, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.topicImport(kodOrganizace, topicEVO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MapioDataImportControllerApi - factory interface
 * @export
 */
export const MapioDataImportControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MapioDataImportControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} kodOrganizace 
         * @param {CatalogItemEVO} [catalogItemEVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogItemImport(kodOrganizace: string, catalogItemEVO?: CatalogItemEVO, options?: any): AxiosPromise<number> {
            return localVarFp.catalogItemImport(kodOrganizace, catalogItemEVO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} layerId 
         * @param {string} kodOrganizace 
         * @param {Array<number>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearOldRecords(layerId: number, kodOrganizace: string, requestBody?: Array<number>, options?: any): AxiosPromise<void> {
            return localVarFp.clearOldRecords(layerId, kodOrganizace, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} kodOrganizace 
         * @param {Array<FeatureExportVO>} [featureExportVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dataImport(kodOrganizace: string, featureExportVO?: Array<FeatureExportVO>, options?: any): AxiosPromise<ImportedDataVO> {
            return localVarFp.dataImport(kodOrganizace, featureExportVO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} kodOrganizace 
         * @param {File} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        imageImport(kodOrganizace: string, body?: File, options?: any): AxiosPromise<void> {
            return localVarFp.imageImport(kodOrganizace, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} kodOrganizace 
         * @param {LayerEVO} [layerEVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        layerImport(kodOrganizace: string, layerEVO?: LayerEVO, options?: any): AxiosPromise<number> {
            return localVarFp.layerImport(kodOrganizace, layerEVO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OrganisationEVO} [organisationEVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organisationImport(organisationEVO?: OrganisationEVO, options?: any): AxiosPromise<void> {
            return localVarFp.organisationImport(organisationEVO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} kodOrganizace 
         * @param {TopicEVO} [topicEVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        topicImport(kodOrganizace: string, topicEVO?: TopicEVO, options?: any): AxiosPromise<void> {
            return localVarFp.topicImport(kodOrganizace, topicEVO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MapioDataImportControllerApi - interface
 * @export
 * @interface MapioDataImportControllerApi
 */
export interface MapioDataImportControllerApiInterface {
    /**
     * 
     * @param {string} kodOrganizace 
     * @param {CatalogItemEVO} [catalogItemEVO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MapioDataImportControllerApiInterface
     */
    catalogItemImport(kodOrganizace: string, catalogItemEVO?: CatalogItemEVO, options?: any): AxiosPromise<number>;

    /**
     * 
     * @param {number} layerId 
     * @param {string} kodOrganizace 
     * @param {Array<number>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MapioDataImportControllerApiInterface
     */
    clearOldRecords(layerId: number, kodOrganizace: string, requestBody?: Array<number>, options?: any): AxiosPromise<void>;

    /**
     * 
     * @param {string} kodOrganizace 
     * @param {Array<FeatureExportVO>} [featureExportVO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MapioDataImportControllerApiInterface
     */
    dataImport(kodOrganizace: string, featureExportVO?: Array<FeatureExportVO>, options?: any): AxiosPromise<ImportedDataVO>;

    /**
     * 
     * @param {string} kodOrganizace 
     * @param {File} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MapioDataImportControllerApiInterface
     */
    imageImport(kodOrganizace: string, body?: File, options?: any): AxiosPromise<void>;

    /**
     * 
     * @param {string} kodOrganizace 
     * @param {LayerEVO} [layerEVO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MapioDataImportControllerApiInterface
     */
    layerImport(kodOrganizace: string, layerEVO?: LayerEVO, options?: any): AxiosPromise<number>;

    /**
     * 
     * @param {OrganisationEVO} [organisationEVO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MapioDataImportControllerApiInterface
     */
    organisationImport(organisationEVO?: OrganisationEVO, options?: any): AxiosPromise<void>;

    /**
     * 
     * @param {string} kodOrganizace 
     * @param {TopicEVO} [topicEVO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MapioDataImportControllerApiInterface
     */
    topicImport(kodOrganizace: string, topicEVO?: TopicEVO, options?: any): AxiosPromise<void>;

}

/**
 * MapioDataImportControllerApi - object-oriented interface
 * @export
 * @class MapioDataImportControllerApi
 * @extends {BaseAPI}
 */
export class MapioDataImportControllerApi extends BaseAPI implements MapioDataImportControllerApiInterface {
    /**
     * 
     * @param {string} kodOrganizace 
     * @param {CatalogItemEVO} [catalogItemEVO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MapioDataImportControllerApi
     */
    public catalogItemImport(kodOrganizace: string, catalogItemEVO?: CatalogItemEVO, options?: any) {
        return MapioDataImportControllerApiFp(this.configuration).catalogItemImport(kodOrganizace, catalogItemEVO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} layerId 
     * @param {string} kodOrganizace 
     * @param {Array<number>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MapioDataImportControllerApi
     */
    public clearOldRecords(layerId: number, kodOrganizace: string, requestBody?: Array<number>, options?: any) {
        return MapioDataImportControllerApiFp(this.configuration).clearOldRecords(layerId, kodOrganizace, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} kodOrganizace 
     * @param {Array<FeatureExportVO>} [featureExportVO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MapioDataImportControllerApi
     */
    public dataImport(kodOrganizace: string, featureExportVO?: Array<FeatureExportVO>, options?: any) {
        return MapioDataImportControllerApiFp(this.configuration).dataImport(kodOrganizace, featureExportVO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} kodOrganizace 
     * @param {File} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MapioDataImportControllerApi
     */
    public imageImport(kodOrganizace: string, body?: File, options?: any) {
        return MapioDataImportControllerApiFp(this.configuration).imageImport(kodOrganizace, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} kodOrganizace 
     * @param {LayerEVO} [layerEVO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MapioDataImportControllerApi
     */
    public layerImport(kodOrganizace: string, layerEVO?: LayerEVO, options?: any) {
        return MapioDataImportControllerApiFp(this.configuration).layerImport(kodOrganizace, layerEVO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OrganisationEVO} [organisationEVO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MapioDataImportControllerApi
     */
    public organisationImport(organisationEVO?: OrganisationEVO, options?: any) {
        return MapioDataImportControllerApiFp(this.configuration).organisationImport(organisationEVO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} kodOrganizace 
     * @param {TopicEVO} [topicEVO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MapioDataImportControllerApi
     */
    public topicImport(kodOrganizace: string, topicEVO?: TopicEVO, options?: any) {
        return MapioDataImportControllerApiFp(this.configuration).topicImport(kodOrganizace, topicEVO, options).then((request) => request(this.axios, this.basePath));
    }
}
